<template>
    <v-container class="pa-5" fluid>
        <SavePaperGroupDialog
            :paper-group="paperGroup"
            :is-open="savePaperGroupDialog"
            @on-save="getPaperGroups"
            @on-close="closeSavePaperGroupDialog"
        />

        <v-row align="center" dense>
            <v-col cols="auto">
                <page-title>Grupy papierów</page-title>
            </v-col>
            <v-col cols="auto">
                <SelectMenu />
            </v-col>
        </v-row>
        <v-row align="center">
            <v-col cols="12" lg="4">
                <v-btn
                    color="secondary"
                    medium
                    data-sentry-label="Dodaj grupę"
                    @click="showCreatePaperGroupDialog"
                >
                    <v-icon left>
                        mdi-plus
                    </v-icon>
                    Dodaj grupę
                </v-btn>
            </v-col>
            <v-col cols="12" lg="8">
                <v-container fluid class="pa-0">
                    <v-row justify="end" dense>
                        <v-col sm="auto">
                            <v-checkbox
                                v-model="filters.isVisible"
                                label="Ukryj nieaktywne"
                                hide-details
                                class="mt-2"
                                @change="changeFilter"
                            />
                        </v-col>
                        <v-col cols="12" sm="3">
                            <v-text-field
                                v-model="filters.name"
                                append-icon="mdi-magnify"
                                label="Szukaj..."
                                single-line
                                clearable
                                hide-details
                                solo
                                @keyup.enter="changeFilter"
                                @click:append="changeFilter"
                                @click:clear="clearFilter('name')"
                            />
                        </v-col>
                    </v-row>
                </v-container>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-data-table
                        :headers="headers"
                        :items="paperGroups"
                        :loading="paperGroupsLoading"
                        :footer-props="footerProps"
                        :server-items-length="pagination.itemsLength"
                        :page.sync="pagination.page"
                        :mobile-breakpoint="0"
                        name="paperGroupsData"
                        @pagination="updatePagination"
                    >
                        <template #item.isVisible="{item}">
                            <v-icon
                                v-if="item.isVisible"
                                small
                                color="success"
                            >
                                mdi-check
                            </v-icon>
                            <v-icon v-else small color="error">
                                mdi-close
                            </v-icon>
                        </template>
                        <template #item.actions="{item}">
                            <div class="d-inline-flex">
                                <v-tooltip :open-delay="tooltipDelay" top>
                                    <template #activator="{on}">
                                        <v-btn
                                            icon
                                            data-sentry-label="Edytuj"
                                            v-on="on"
                                            @click="showEditPaperGroupDialog(item.id)"
                                        >
                                            <v-icon color="teal">
                                                mdi-pencil
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Edytuj</span>
                                </v-tooltip>
                                <v-tooltip :open-delay="tooltipDelay" top>
                                    <template #activator="{on}">
                                        <v-btn
                                            icon
                                            data-sentry-label="Usuń"
                                            v-on="on"
                                            @click="hidePaperGroup(item.id)"
                                        >
                                            <v-icon color="pink">
                                                mdi-eye-off
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Usuń</span>
                                </v-tooltip>
                            </div>
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import PageTitle from '@/components/common/PageTitle'
import SavePaperGroupDialog from './SavePaperGroupDialog'
import filters from '@/mixins/dataTableFilters'
import pagination from '@/mixins/dataTablePagination'
import tooltipDelay from '@/mixins/tooltip'
import { errorHandler } from '@/utils/errorHandler'
import SelectMenu from '@/views/Configurations/Materials/Common/SelectMenu'

export default {
    name: 'PaperGroups',
    components: {
        PageTitle,
        SavePaperGroupDialog,
        SelectMenu
    },
    mixins: [
        filters,
        pagination,
        tooltipDelay
    ],
    beforeRouteLeave(to, from, next) {
        this.$store.dispatch('configurations/clearPaperGroupsFilters')
        next()
    },
    data() {
        return {
            paperGroup: {},
            savePaperGroupDialog: false,
            headers: [
                {
                    text: 'Nazwa',
                    value: 'name',
                    sortable: false
                },
                {
                    text: 'Czy aktywna?',
                    value: 'isVisible',
                    sortable: false,
                    align: 'center',
                    width: 60
                },
                {
                    text: 'Akcje',
                    value: 'actions',
                    sortable: false,
                    align: 'center',
                    width: 100
                }
            ]
        }
    },
    computed: {
        paperGroups() {
            return this.$store.getters['configurations/getPaperGroups']
        },
        paperGroupsLoading() {
            return this.$store.state.configurations.paperGroups.paperGroupsLoading
        },
        savedFilters() {
            return this.$store.state.configurations.paperGroups.filters
        },
        filterQuery() {
            const filters = this.filters
            let query = ''

            for (let item in filters) {
                if (filters[item] != null && filters[item] != '') {
                    if (!(item === 'isVisible' && filters[item] === false)) {
                        query = query.concat('&', `${item}=${filters[item]}`)
                    }
                }
            }

            return query
        }
    },
    mounted() {
        this.getPaperGroups()
    },
    methods: {
        getPaperGroups() {
            this.$store.dispatch('configurations/getPaperGroups', {
                paginate: this.paginate(),
                query: this.filterQuery
            })
                .then(response => {
                    this.handlePaginationResponse(response)
                })
                .catch(error => {
                    errorHandler(error)
                })
        },
        getPaperGroup(id) {
            return this.$store.getters['configurations/getPaperGroupById'](id)
        },
        showCreatePaperGroupDialog() {
            this.savePaperGroupDialog = true
        },
        showEditPaperGroupDialog(id) {
            this.paperGroup = this.getPaperGroup(id)
            this.savePaperGroupDialog = true
        },
        closeSavePaperGroupDialog() {
            this.savePaperGroupDialog = false

            setTimeout(() => {
                this.paperGroup = {}
            }, 500)
        },
        hidePaperGroup(id) {
            this.$store.dispatch('configurations/updatePaperGroup', {
                id: id,
                isVisible: false
            })
                .then(() => {
                    this.getPaperGroups()
                })
                .catch(error => {
                    errorHandler(error)
                })
        },
        changeFilter() {
            this.$store.dispatch('configurations/setPaperGroupsFilters', this.filters)
            this.resetPagination()
            this.getPaperGroups()
        },
        updatePagination(pagination) {
            this.pagination = pagination

            if (pagination.pageCount !== 0 && !this.paginationSettings.paginationPending) {
                this.getPaperGroups()
            }
            this.clearPaginationPending()
        }
    }
}
</script>
